export const filterMenuItems = (items, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return items
  }

  const term = searchTerm.toLowerCase().trim()
  const itemMatchesSearch = item => {
    if (item.label.toLowerCase().includes(term)) {
      return true
    }

    if (item.subItems && item.subItems.length > 0) {
      return item.subItems.some(subItem => itemMatchesSearch(subItem))
    }

    return false
  }

  return items
    .map(item => {
      if (itemMatchesSearch(item)) {
        let clonedItem = { ...item }
        if (item.subItems && item.subItems.length > 0) {
          clonedItem.subItems = filterMenuItems(item.subItems, searchTerm)
        }

        return clonedItem
      }

      return null
    })
    .filter(Boolean)
}

export const itemMatchesSearch = (item, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return false
  }

  const term = searchTerm.toLowerCase().trim()

  if (item.label.toLowerCase().includes(term)) {
    return true
  }
  if (item.subItems && item.subItems.length > 0) {
    return item.subItems.some(subItem => itemMatchesSearch(subItem, term))
  }

  return false
}

export const getMatchingPaths = (items, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return []
  }

  const paths = new Set()

  const findPaths = (items, parentPath = []) => {
    items.forEach(item => {
      const currentPath = [...parentPath, item.id]
      const matches = item.label.toLowerCase().includes(searchTerm.toLowerCase())

      if (matches) {
        currentPath.forEach(id => paths.add(id))
      }

      if (item.subItems && item.subItems.length > 0) {
        findPaths(item.subItems, currentPath)
      }
    })
  }

  findPaths(items)
  return Array.from(paths)
}
